/**
 * Pure logic for "copy packing list from another event" with optional wish list.
 * When includeWishList is true: copy quantity = pack - wish per item type; only include items where net > 0.
 */

export interface CopyItem {
    itemTypeId: string;
    quantity: number;
}

/**
 * Compute which items to copy and their quantities.
 * @param packByItemType - packing list quantity per item type (source event)
 * @param wishByItemType - wish list quantity per item type (source event), used only when includeWishList is true
 * @param includeWishList - if true, copy quantity = pack - wish and skip items where pack - wish <= 0
 * @returns array of { itemTypeId, quantity } to copy
 */
export function computeItemsToCopy(
    packByItemType: Map<string, number>,
    wishByItemType: Map<string, number>,
    includeWishList: boolean
): CopyItem[] {
    const result: CopyItem[] = [];
    if (includeWishList) {
        for (const [itemTypeId, packQty] of Array.from(packByItemType)) {
            const wishQty = wishByItemType.get(itemTypeId) ?? 0;
            const netQty = packQty - wishQty;
            if (netQty > 0) {
                result.push({ itemTypeId, quantity: netQty });
            }
        }
    } else {
        for (const [itemTypeId, quantity] of Array.from(packByItemType)) {
            result.push({ itemTypeId, quantity });
        }
    }
    return result;
}
